/**
 * @flow
 * @relayHash c552d254e956d05958f636923efd61bb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FormBuilder_form$ref = any;
type JobYieldPanels_jobYieldEdges$ref = any;
export type OverUnderRule = "ALLOW_OVERS" | "NO_OVERS" | "NO_UNDERS";
export type AddJobYieldInput = {|
  jobId: string,
  itemId: string,
  quantity: number,
  itemNumberUp: number,
  brokerCustomerOrderNumber?: ?string,
  overUnderRule?: ?OverUnderRule,
  overQuantity?: ?number,
  formFieldValues?: ?any,
|};
export type AddJobYieldMutationVariables = {|
  input: AddJobYieldInput
|};
export type AddJobYieldMutationResponse = {|
  +addJobYield: {|
    +jobYieldEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +quantity: number,
        +itemNumberUp: number,
        +brokerCustomerOrderNumber: ?string,
        +formFieldValues: any,
        +overUnderRule: ?OverUnderRule,
        +overQuantity: ?number,
        +job: {|
          +id: string,
          +yields: {|
            +totalCount: number
          |},
        |},
        +item: {|
          +id: string,
          +itemNumber: string,
          +name: string,
          +partNumber: ?string,
          +description: ?string,
          +formFieldValues: any,
          +form: {|
            +$fragmentRefs: FormBuilder_form$ref
          |},
        |},
        +form: {|
          +id: string,
          +$fragmentRefs: FormBuilder_form$ref,
        |},
      |},
      +$fragmentRefs: JobYieldPanels_jobYieldEdges$ref,
    |}
  |}
|};
export type AddJobYieldMutation = {|
  variables: AddJobYieldMutationVariables,
  response: AddJobYieldMutationResponse,
|};
*/


/*
mutation AddJobYieldMutation(
  $input: AddJobYieldInput!
) {
  addJobYield(input: $input) {
    jobYieldEdge {
      ...JobYieldPanels_jobYieldEdges
      cursor
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        job {
          id
          yields {
            totalCount
          }
        }
        item {
          id
          itemNumber
          name
          partNumber
          description
          formFieldValues
          form {
            ...FormBuilder_form
            id
          }
        }
        form {
          id
          ...FormBuilder_form
        }
      }
    }
  }
}

fragment JobYieldPanels_jobYieldEdges on JobYieldEdge {
  node {
    id
    quantity
    itemNumberUp
    brokerCustomerOrderNumber
    formFieldValues
    form {
      id
      ...FormBuilder_form
      fields {
        id
        systemKey
        name
        type
      }
    }
    item {
      id
      itemNumber
      name
      description
      partNumber
      formFieldValues
      quantityUOM {
        id
        symbol
      }
      form {
        id
        ...FormBuilder_form
        fields {
          id
          systemKey
          name
          type
        }
      }
    }
    ...AddUpdateJobYieldModal_jobYield
    ...DeleteJobYieldModal_jobYield
    ...YieldProgressBar_jobYield
  }
}

fragment FormBuilder_form on Form {
  id
  name
  type
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment AddUpdateJobYieldModal_jobYield on JobYield {
  id
  quantity
  itemNumberUp
  brokerCustomerOrderNumber
  formFieldValues
  overUnderRule
  overQuantity
  item {
    id
    quantityUOM {
      id
      name
      symbol
    }
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
    }
  }
}

fragment DeleteJobYieldModal_jobYield on JobYield {
  id
  item {
    id
    name
  }
}

fragment YieldProgressBar_jobYield on JobYield {
  id
  itemNumberUp
  quantity
  finalQuantity
  overUnderRule
  overQuantity
  item {
    id
    name
    quantityUOM {
      id
      symbol
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddJobYieldInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumberUp",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "brokerCustomerOrderNumber",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "overUnderRule",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "overQuantity",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "job",
  "storageKey": null,
  "args": null,
  "concreteType": "Job",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "yields",
      "storageKey": null,
      "args": null,
      "concreteType": "JobYieldConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "FragmentSpread",
  "name": "FormBuilder_form",
  "args": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "form",
  "storageKey": null,
  "args": null,
  "concreteType": "Form",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v12/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "productionType",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductionType",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "fields",
      "storageKey": null,
      "args": null,
      "concreteType": "FormField",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v17/*: any*/),
        (v16/*: any*/),
        (v12/*: any*/),
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "placeholder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isRequired",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isCreatable",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "applicationType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayOrder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "properties",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "options",
          "storageKey": null,
          "args": null,
          "concreteType": "FormFieldOption",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "value",
              "args": null,
              "storageKey": null
            },
            (v3/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddJobYieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "addJobYield",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJobYieldPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobYieldEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobYieldEdge",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "JobYield",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "form",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Form",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "form",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Form",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "JobYieldPanels_jobYieldEdges",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AddJobYieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "addJobYield",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJobYieldPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobYieldEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobYieldEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "JobYield",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v13/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quantityUOM",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UOM",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ]
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "finalQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddJobYieldMutation",
    "id": null,
    "text": "mutation AddJobYieldMutation(\n  $input: AddJobYieldInput!\n) {\n  addJobYield(input: $input) {\n    jobYieldEdge {\n      ...JobYieldPanels_jobYieldEdges\n      cursor\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        job {\n          id\n          yields {\n            totalCount\n          }\n        }\n        item {\n          id\n          itemNumber\n          name\n          partNumber\n          description\n          formFieldValues\n          form {\n            ...FormBuilder_form\n            id\n          }\n        }\n        form {\n          id\n          ...FormBuilder_form\n        }\n      }\n    }\n  }\n}\n\nfragment JobYieldPanels_jobYieldEdges on JobYieldEdge {\n  node {\n    id\n    quantity\n    itemNumberUp\n    brokerCustomerOrderNumber\n    formFieldValues\n    form {\n      id\n      ...FormBuilder_form\n      fields {\n        id\n        systemKey\n        name\n        type\n      }\n    }\n    item {\n      id\n      itemNumber\n      name\n      description\n      partNumber\n      formFieldValues\n      quantityUOM {\n        id\n        symbol\n      }\n      form {\n        id\n        ...FormBuilder_form\n        fields {\n          id\n          systemKey\n          name\n          type\n        }\n      }\n    }\n    ...AddUpdateJobYieldModal_jobYield\n    ...DeleteJobYieldModal_jobYield\n    ...YieldProgressBar_jobYield\n  }\n}\n\nfragment FormBuilder_form on Form {\n  id\n  name\n  type\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment AddUpdateJobYieldModal_jobYield on JobYield {\n  id\n  quantity\n  itemNumberUp\n  brokerCustomerOrderNumber\n  formFieldValues\n  overUnderRule\n  overQuantity\n  item {\n    id\n    quantityUOM {\n      id\n      name\n      symbol\n    }\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment DeleteJobYieldModal_jobYield on JobYield {\n  id\n  item {\n    id\n    name\n  }\n}\n\nfragment YieldProgressBar_jobYield on JobYield {\n  id\n  itemNumberUp\n  quantity\n  finalQuantity\n  overUnderRule\n  overQuantity\n  item {\n    id\n    name\n    quantityUOM {\n      id\n      symbol\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bdec033b6aea4fb874686e3fbb8ab931';
module.exports = node;
